var _linearGradient, _linearGradient2, _linearGradient3, _clipPath, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFevergyBrandLight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 188 32",
    width: 188,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#01aeff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3df"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: 16.424,
    x2: 16.424,
    xlinkHref: "#a",
    y1: 13.1236,
    y2: 2.63037
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: 16.4567,
    x2: 16.4567,
    xlinkHref: "#a",
    y1: 23.5519,
    y2: 13.1238
  })), _clipPath || (_clipPath = /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m0 0h188v32h-188z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#0a0a3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m50.9256 4.06567h-14.2922v23.93423h4.7185v-9.2317h9.3002v-4.5133h-9.3002v-5.67591h9.5737z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m60.4499 18.1185h9.0608v-4.4449h-9.0608v-5.09461h9.9156v-4.51332h-14.6341v23.93423h14.805v-4.5133h-10.0865z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m86.992 27.9999 8.0693-23.93423h-5.163l-5.8126 18.39523-5.8468-18.39523h-5.1287l8.035 23.93423z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m103.454 18.1185h9.061v-4.4449h-9.061v-5.09461h9.916v-4.51332h-14.6344v23.93423h14.8054v-4.5133h-10.087z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m136.458 27.9999-5.299-9.0266c2.769-1.2651 4.616-4.0004 4.616-6.9751 0-2.18831-.787-4.06886-2.325-5.60749-1.539-1.53863-3.42-2.32504-5.642-2.32504h-9.574v23.93423h4.719v-8.3086h3.59l4.821 8.3086zm-8.65-19.52349c1.778 0 3.248 1.57289 3.248 3.52179s-1.47 3.5559-3.248 3.5559h-4.855v-7.07769z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m151.826 15.1437v4.1714h7.248c-.854 2.838-3.316 4.5475-6.975 4.5475-2.461 0-4.445-.718-5.949-2.1882-1.47-1.4703-2.223-3.3508-2.223-5.6075 0-2.2908.719-4.1714 2.189-5.6416 1.47-1.50447 3.351-2.25669 5.641-2.25669 2.838 0 5.3 1.36767 6.428 3.31659l4.035-2.32502c-2.051-3.38499-5.949-5.57327-10.428-5.57327-3.556 0-6.531 1.19672-8.959 3.62433-2.393 2.42762-3.59 5.36816-3.59 8.85566 0 3.4534 1.197 6.3939 3.625 8.8215 2.427 2.3934 5.504 3.5901 9.197 3.5901 3.454 0 6.291-1.0599 8.48-3.1798 2.188-2.1199 3.282-4.8894 3.282-8.3086v-1.8464z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m180.423 4.06567-5.197 9.98403-5.197-9.98403h-5.334l8.172 14.59993v9.3343h4.684v-9.3343l8.206-14.59993z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m0 17.8164h11.4708v11.4708h-11.4708z",
    fill: "#6d00cc"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 17.8164h13.6868l11.4708 11.4708h-13.6868z",
    fill: "#1b0033"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.4238 13.1236h-13.75363v-10.49323h21.50773z",
    fill: "url(#b)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m19.4239 23.5519h-13.68855v-10.4281h21.44265z",
    fill: "url(#c)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m5.67024 13.1238h8.27726l-8.21209 10.4281v-5.7355h-5.73541v-15.18578h13.4261z",
    fill: "#33f"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFevergyBrandLight);
export default __webpack_public_path__ + "static/media/fevergy-brand-light.9bf6215566b668e7f9823f7ce9ef4d0a.svg";
export { ForwardRef as ReactComponent };